import React, { useEffect } from "react";
import { useAuth } from "@clerk/clerk-react";
import { setGetTokenFunction } from "../utils/clerk";

/**
 * Component that initializes the Clerk token function for RTK Query
 * This ensures that API requests always use fresh tokens from Clerk
 */
export const ClerkTokenInitializer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { getToken } = useAuth();

  useEffect(() => {
    // Set up the token function that RTK Query will use
    setGetTokenFunction(async () => {
      try {
        return await getToken();
      } catch (error) {
        console.warn("Failed to get fresh token from Clerk:", error);
        return null;
      }
    });

    // Cleanup function to remove the token function when component unmounts
    return () => {
      setGetTokenFunction(null);
    };
  }, [getToken]);

  return <>{children}</>;
};
